// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 基础 Header 设置 */
header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 70px;
    z-index: 1000;
    background: var(--glass-bg, rgba(255, 255, 255, 0.8));
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--border-color, #eaeaea);
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
}

header.scrolled {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 4px 20px rgba(0,0,0,0.05);
}

/* PC端暗色遮罩层 */
.menu-backdrop {
    position: fixed;
    top: 70px;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 999;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    backdrop-filter: blur(2px);
}
.menu-backdrop.active {
    opacity: 1;
    visibility: visible;
}

.nav-container {
    width: 90%;
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
}

.logo {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.5rem;
    font-weight: 800;
    letter-spacing: 0px;
    color: #E50112;
    text-decoration: none;
    z-index: 1001; /* 确保移动端展开时logo在上层 */
    font-family: inherit;
}
.logo img { height: 32px; width: auto; object-fit: contain; }

.nav-links {
    display: flex;
    gap: 2.5rem;
    height: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
}

.mobile-lang-panel {
    display: none;
}

.nav-item {
    height: 100%;
    display: flex;
    align-items: center;
}

.nav-label {
    cursor: pointer;
    font-weight: 500;
    font-size: 0.95rem;
    color: var(--text-main, #333);
    display: flex;
    align-items: center;
    gap: 6px;
    transition: color 0.2s ease;
    text-decoration: none;
    position: relative;
    padding: 10px 0;
}

.nav-label .arrow {
    font-size: 0.6rem;
    transition: transform 0.3s ease;
}

/* 底部红线动画 */
.nav-label::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 50%;
    width: 0;
    height: 2px;
    background: var(--accent-red, #d9001b);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-50%);
}

.nav-label:hover, .nav-label.active { color: var(--accent-red, #d9001b); }
.nav-label.active .arrow { transform: rotate(180deg); }
.nav-label.active::after { width: 100%; }

/* ==================================
   全宽 Mega Menu (PC端)
================================== */
.mega-menu {
    position: absolute;
    top: 70px;
    left: 0;
    right: 0;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid var(--border-color, #eaeaea);
    box-shadow: 0 10px 30px rgba(0,0,0,0.08);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
}

.mega-menu.open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    pointer-events: auto;
}

/* 内部内容约束在安全区内 */
.mega-content {
    width: 90%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 40px 0;
    display: flex;
    justify-content: center; /* 居中内容更专业 */
    gap: 60px;
}

.mega-content.single-column {
    justify-content: flex-start;
    padding-left: calc(5% + 200px); /* 让小菜单对齐上面的文字 */
}

.mega-content.services-menu {
    justify-content: center;
    padding: 32px 0 36px;
}

.services-menu-grid {
    width: 100%;
    max-width: 720px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 22px;
}

.service-feature-card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px 26px;
    border-radius: 22px;
    text-decoration: none;
    color: var(--text-main, #333);
    background:
        radial-gradient(circle at top right, rgba(217, 0, 27, 0.08), transparent 34%),
        linear-gradient(145deg, #ffffff 0%, #f7f7f7 100%);
    border: 1px solid rgba(217, 0, 27, 0.14);
    box-shadow: 0 16px 36px rgba(0,0,0,0.06);
    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.service-feature-card:hover {
    transform: translateY(-4px);
    border-color: rgba(217, 0, 27, 0.35);
    box-shadow: 0 20px 40px rgba(217, 0, 27, 0.12);
}

.service-feature-tag {
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--accent-red, #d9001b);
}

.service-feature-title {
    font-size: 1.05rem;
    font-weight: 600;
    line-height: 1.6;
    color: var(--text-main, #333);
}

.mega-divider {
    width: 1px;
    background: var(--border-color, #eaeaea);
    margin: 0 20px;
}

.mega-section { display: flex; flex-direction: column; flex: 1; max-width: 500px; }
.mega-columns { display: flex; gap: 40px; margin-top: 15px; }
.mega-column { flex: 1; }

.mega-title {
    font-size: 1.2rem;
    color: var(--accent-red, #d9001b);
    font-weight: 700;
    border-bottom: 2px solid var(--accent-red, #d9001b);
    padding-bottom: 8px;
    display: inline-block;
    width: fit-content;
}

.overseas-title { color: #666; border-color: transparent; }

.mega-subtitle {
    font-size: 1.05rem;
    color: var(--accent-red, #d9001b);
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
}
.mega-subtitle::before { content: '▶'; font-size: 0.65rem; }

.mega-list {
    border-left: 2px solid var(--accent-red, #d9001b);
    padding-left: 15px;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.mega-list.no-border { border-left: none; padding-left: 0; margin-left: 0; }

.mega-list a {
    color: #555;
    font-size: 0.95rem;
    text-decoration: none;
    transition: all 0.2s ease;
    position: relative;
    width: fit-content;
}

.mega-list a:hover {
    color: var(--accent-red, #d9001b);
    transform: translateX(5px); /* 悬浮小动效 */
}

.nav-item > .mega-menu.small {
    min-width: 280px;
}

/* 杂项 */
.nav-actions { display: flex; align-items: center; gap: 20px; z-index: 1001; }
.lang-switch { font-size: 0.85rem; border: 1px solid var(--border-color, #eaeaea); padding: 4px 12px; border-radius: 20px; cursor: pointer; }

/* 移动端汉堡按钮 */
.mobile-menu-btn {
    display: none;
    flex-direction: column;
    gap: 6px;
    cursor: pointer;
    width: 30px;
    height: 24px;
    justify-content: center;
}
.mobile-menu-btn span {
    width: 100%;
    height: 2px;
    background: var(--text-main, #333);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 2px;
}

/* 汉堡变X动画 */
.mobile-menu-btn.open span:nth-child(1) { transform: translateY(8px) rotate(45deg); }
.mobile-menu-btn.open span:nth-child(2) { opacity: 0; transform: translateX(-10px); }
.mobile-menu-btn.open span:nth-child(3) { transform: translateY(-8px) rotate(-45deg); }

/* ==================================
   移动端响应式 (<= 992px)
================================== */
@media (max-width: 992px) {
    .nav-actions { display: flex; }
    .lang-switch { display: none; } /* 移动端可以考虑把语言切换放到菜单里面，这里先隐藏 */
    .mobile-menu-btn { display: flex; }

    /* 移动端侧边抽屉/全屏菜单 */
    .nav-links {
        position: fixed;
        top: 70px;
        left: -100%; /* 默认隐藏在左侧 */
        width: 100vw;
        height: calc(100vh - 70px);
        background: #fff;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding: 20px;
        gap: 0;
        transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        overflow-y: auto;
    }

    .mobile-lang-panel {
        display: grid;
        gap: 10px;
        padding: 0 0 18px;
        margin-bottom: 6px;
        border-bottom: 1px solid var(--border-color, #eaeaea);
        list-style: none;
    }

    .mobile-lang-title {
        font-size: 0.76rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--text-light, #666);
        padding: 0 10px;
    }

    .mobile-lang-options {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        padding: 0 10px;
    }

    .mobile-lang-option {
        appearance: none;
        border: 1px solid var(--border-color, #eaeaea);
        background: #fff;
        color: var(--text-main, #333);
        border-radius: 999px;
        padding: 8px 14px;
        font-size: 0.92rem;
        font-weight: 600;
        line-height: 1;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .mobile-lang-option.active {
        background: var(--accent-red, #d9001b);
        border-color: var(--accent-red, #d9001b);
        color: #fff;
    }

    .nav-links.active { left: 0; }

    .nav-item {
        height: auto;
        flex-direction: column;
        align-items: flex-start;
        border-bottom: 1px solid var(--border-color, #eaeaea);
        width: 100%;
    }

    .nav-label {
        width: 100%;
        padding: 20px 10px;
        font-size: 1.1rem;
        display: flex;
        justify-content: space-between; /* 文字和箭头分开 */
    }
    .nav-label::after { display: none; } /* 移动端不需要底边红线 */

    /* 移动端 Mega Menu (手风琴效果) */
    .mega-menu {
        position: static;
        width: 100%;
        opacity: 1;
        visibility: visible;
        box-shadow: none;
        border: none;
        transform: none;
        background: #fcfcfc;
        /* 手风琴动画核心 */
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.4s ease-in-out;
        pointer-events: auto;
    }

    .mega-menu.open {
        max-height: 1500px; /* 足够大以容纳内容 */
    }

    .mega-content {
        width: 100%;
        padding: 10px 20px 30px 20px;
        flex-direction: column;
        gap: 30px;
    }
    .mega-content.single-column { padding-left: 20px; }
    .services-menu-grid { grid-template-columns: 1fr; }
    .service-feature-card {
        display: block;
        width: fit-content;
        padding: 0;
        margin: 0;
        border-radius: 0;
        background: transparent;
        border: none;
        box-shadow: none;
        color: #555;
        transition: color 0.2s ease;
    }
    .service-feature-tag {
        display: none;
    }
    .service-feature-title {
        font-size: 0.95rem;
        font-weight: 400;
        line-height: 1.6;
        color: inherit;
    }
    .service-feature-card:hover { transform: none; color: var(--accent-red, #d9001b); }

    .mega-columns { flex-direction: column; gap: 20px; }
    .mega-divider { width: 100%; height: 1px; margin: 10px 0; }

    .mega-list a:hover { transform: none; color: var(--accent-red, #d9001b); }
}
@media (max-width: 992px) {
    /* 核心修复：在手机端彻底禁用 PC 端的背景遮罩，防止逻辑冲突 */
    .menu-backdrop {
        display: none !important;
    }

    .nav-actions { display: flex; }
    .lang-switch { display: none; }
    .mobile-menu-btn { display: flex; }

    .nav-links {
        position: fixed;
        top: 70px;
        left: -100%;
        width: 100vw;
        height: calc(100vh - 70px);
        background: #fff;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding: 20px;
        gap: 0;
        transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        overflow-y: auto;
        z-index: 1000;
    }

    .mobile-lang-panel {
        display: grid;
    }

    .nav-links.active { left: 0; }

    /* 移动端菜单项样式 */
    .nav-item {
        height: auto;
        flex-direction: column;
        align-items: flex-start;
        border-bottom: 1px solid #eee;
        width: 100%;
    }

    .nav-label {
        width: 100%;
        padding: 20px 10px;
        font-size: 1.1rem;
        display: flex;
        justify-content: space-between;
    }
    .nav-label::after { display: none; }

    /* 手机端展开动画 */
    .mega-menu {
        position: static;
        width: 100%;
        opacity: 1;
        visibility: visible;
        box-shadow: none;
        border: none;
        transform: none;
        background: #f9f9f9;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.4s ease-in-out; /* 关键：展开动画 */
    }

    .mega-menu.open {
        max-height: 2000px; /* 设一个足够大的高度以容纳长列表 */
    }

    .mega-content {
        width: 100%;
        padding: 8px 10px 18px 10px;
        flex-direction: column;
        gap: 12px;
    }

    .mega-content.single-column { padding-left: 10px; }
    .services-menu-grid {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding-left: 15px;
        margin-left: 5px;
    }
    .service-feature-card {
        width: fit-content;
        padding: 0;
        margin: 0;
        border-radius: 0;
        background: transparent;
        border: none;
        box-shadow: none;
        color: #555;
        transition: color 0.2s ease;
    }
    .service-feature-tag {
        display: none;
    }
    .service-feature-title {
        font-size: 0.95rem;
        font-weight: 400;
        line-height: 1.6;
        color: inherit;
    }
    .service-feature-card:hover { transform: none; color: var(--accent-red, #d9001b); }
    .mega-columns { flex-direction: column; gap: 20px; }
    .mega-divider { display: none; } /* 手机端不需要分割线 */
}
`, "",{"version":3,"sources":["webpack://./src/styles/header.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qDAAqD;IACrD,2BAA2B;IAC3B,mCAAmC;IACnC,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA,aAAa;AACb;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,OAAO;IACP,QAAQ;IACR,8BAA8B;IAC9B,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,aAAa,EAAE,oBAAoB;IACnC,oBAAoB;AACxB;AACA,YAAY,YAAY,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAE5D;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA,WAAW;AACX;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,WAAW;IACX,sCAAsC;IACtC,iDAAiD;IACjD,2BAA2B;AAC/B;;AAEA,sCAAsC,iCAAiC,EAAE;AACzE,2BAA2B,yBAAyB,EAAE;AACtD,2BAA2B,WAAW,EAAE;;AAExC;;oCAEoC;AACpC;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,qDAAqD;IACrD,wCAAwC;IACxC,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,iDAAiD;IACjD,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA,gBAAgB;AAChB;IACI,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,uBAAuB,EAAE,YAAY;IACrC,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B,EAAE,gBAAgB;AACpD;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,6BAA6B;IAC7B;;yDAEqD;IACrD,wCAAwC;IACxC,wCAAwC;IACxC,gFAAgF;AACpF;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,wCAAwC;IACxC,cAAc;AAClB;;AAEA,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,OAAO,EAAE,gBAAgB,EAAE;AAClF,gBAAgB,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC5D,eAAe,OAAO,EAAE;;AAExB;IACI,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;IAChB,mDAAmD;IACnD,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,kBAAkB,WAAW,EAAE,yBAAyB,EAAE;;AAE1D;IACI,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;AACA,yBAAyB,YAAY,EAAE,kBAAkB,EAAE;;AAE3D;IACI,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA,uBAAuB,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE;;AAE3E;IACI,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,0BAA0B,EAAE,UAAU;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA,OAAO;AACP,eAAe,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,aAAa,EAAE;AAC7E,eAAe,kBAAkB,EAAE,8CAA8C,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAE5I,YAAY;AACZ;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,WAAW;IACX,kCAAkC;IAClC,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA,WAAW;AACX,0CAA0C,wCAAwC,EAAE;AACpF,0CAA0C,UAAU,EAAE,4BAA4B,EAAE;AACpF,0CAA0C,0CAA0C,EAAE;;AAEtF;;oCAEoC;AACpC;IACI,eAAe,aAAa,EAAE;IAC9B,eAAe,aAAa,EAAE,EAAE,6BAA6B;IAC7D,mBAAmB,aAAa,EAAE;;IAElC,iBAAiB;IACjB;QACI,eAAe;QACf,SAAS;QACT,WAAW,EAAE,YAAY;QACzB,YAAY;QACZ,0BAA0B;QAC1B,gBAAgB;QAChB,sBAAsB;QACtB,2BAA2B;QAC3B,oBAAoB;QACpB,aAAa;QACb,MAAM;QACN,kDAAkD;QAClD,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,iBAAiB;QACjB,kBAAkB;QAClB,qDAAqD;QACrD,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,sBAAsB;QACtB,yBAAyB;QACzB,8BAA8B;QAC9B,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,8CAA8C;QAC9C,gBAAgB;QAChB,6BAA6B;QAC7B,oBAAoB;QACpB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,sCAAsC;QACtC,wCAAwC;QACxC,WAAW;IACf;;IAEA,oBAAoB,OAAO,EAAE;;IAE7B;QACI,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,qDAAqD;QACrD,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,iBAAiB;QACjB,aAAa;QACb,8BAA8B,EAAE,YAAY;IAChD;IACA,oBAAoB,aAAa,EAAE,EAAE,eAAe;;IAEpD,0BAA0B;IAC1B;QACI,gBAAgB;QAChB,WAAW;QACX,UAAU;QACV,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,mBAAmB;QACnB,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,uCAAuC;QACvC,oBAAoB;IACxB;;IAEA;QACI,kBAAkB,EAAE,aAAa;IACrC;;IAEA;QACI,WAAW;QACX,4BAA4B;QAC5B,sBAAsB;QACtB,SAAS;IACb;IACA,8BAA8B,kBAAkB,EAAE;IAClD,sBAAsB,0BAA0B,EAAE;IAClD;QACI,cAAc;QACd,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,gBAAgB;QAChB,uBAAuB;QACvB,YAAY;QACZ,gBAAgB;QAChB,WAAW;QACX,2BAA2B;IAC/B;IACA;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;IAClB;IACA,8BAA8B,eAAe,EAAE,iCAAiC,EAAE;;IAElF,gBAAgB,sBAAsB,EAAE,SAAS,EAAE;IACnD,gBAAgB,WAAW,EAAE,WAAW,EAAE,cAAc,EAAE;;IAE1D,qBAAqB,eAAe,EAAE,iCAAiC,EAAE;AAC7E;AACA;IACI,mCAAmC;IACnC;QACI,wBAAwB;IAC5B;;IAEA,eAAe,aAAa,EAAE;IAC9B,eAAe,aAAa,EAAE;IAC9B,mBAAmB,aAAa,EAAE;;IAElC;QACI,eAAe;QACf,SAAS;QACT,WAAW;QACX,YAAY;QACZ,0BAA0B;QAC1B,gBAAgB;QAChB,sBAAsB;QACtB,2BAA2B;QAC3B,oBAAoB;QACpB,aAAa;QACb,MAAM;QACN,kDAAkD;QAClD,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA,oBAAoB,OAAO,EAAE;;IAE7B,aAAa;IACb;QACI,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,6BAA6B;QAC7B,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,iBAAiB;QACjB,aAAa;QACb,8BAA8B;IAClC;IACA,oBAAoB,aAAa,EAAE;;IAEnC,YAAY;IACZ;QACI,gBAAgB;QAChB,WAAW;QACX,UAAU;QACV,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,mBAAmB;QACnB,aAAa;QACb,gBAAgB;QAChB,uCAAuC,EAAE,YAAY;IACzD;;IAEA;QACI,kBAAkB,EAAE,oBAAoB;IAC5C;;IAEA;QACI,WAAW;QACX,2BAA2B;QAC3B,sBAAsB;QACtB,SAAS;IACb;;IAEA,8BAA8B,kBAAkB,EAAE;IAClD;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,gBAAgB;QAChB,uBAAuB;QACvB,YAAY;QACZ,gBAAgB;QAChB,WAAW;QACX,2BAA2B;IAC/B;IACA;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;IAClB;IACA,8BAA8B,eAAe,EAAE,iCAAiC,EAAE;IAClF,gBAAgB,sBAAsB,EAAE,SAAS,EAAE;IACnD,gBAAgB,aAAa,EAAE,EAAE,cAAc;AACnD","sourcesContent":["/* 基础 Header 设置 */\r\nheader {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 70px;\r\n    z-index: 1000;\r\n    background: var(--glass-bg, rgba(255, 255, 255, 0.8));\r\n    backdrop-filter: blur(12px);\r\n    -webkit-backdrop-filter: blur(12px);\r\n    border-bottom: 1px solid var(--border-color, #eaeaea);\r\n    display: flex;\r\n    align-items: center;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\nheader.scrolled {\r\n    background: rgba(255, 255, 255, 0.98);\r\n    box-shadow: 0 4px 20px rgba(0,0,0,0.05);\r\n}\r\n\r\n/* PC端暗色遮罩层 */\r\n.menu-backdrop {\r\n    position: fixed;\r\n    top: 70px;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    background: rgba(0, 0, 0, 0.4);\r\n    z-index: 999;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: all 0.3s ease;\r\n    backdrop-filter: blur(2px);\r\n}\r\n.menu-backdrop.active {\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n\r\n.nav-container {\r\n    width: 90%;\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    height: 100%;\r\n}\r\n\r\n.logo {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    font-size: 1.5rem;\r\n    font-weight: 800;\r\n    letter-spacing: 0px;\r\n    color: #E50112;\r\n    text-decoration: none;\r\n    z-index: 1001; /* 确保移动端展开时logo在上层 */\r\n    font-family: inherit;\n}\r\n.logo img { height: 32px; width: auto; object-fit: contain; }\r\n\r\n.nav-links {\n    display: flex;\n    gap: 2.5rem;\n    height: 100%;\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\n}\n\n.mobile-lang-panel {\n    display: none;\n}\n\r\n.nav-item {\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.nav-label {\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n    font-size: 0.95rem;\r\n    color: var(--text-main, #333);\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    transition: color 0.2s ease;\r\n    text-decoration: none;\r\n    position: relative;\r\n    padding: 10px 0;\r\n}\r\n\r\n.nav-label .arrow {\r\n    font-size: 0.6rem;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n/* 底部红线动画 */\r\n.nav-label::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -4px;\r\n    left: 50%;\r\n    width: 0;\r\n    height: 2px;\r\n    background: var(--accent-red, #d9001b);\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    transform: translateX(-50%);\r\n}\r\n\r\n.nav-label:hover, .nav-label.active { color: var(--accent-red, #d9001b); }\r\n.nav-label.active .arrow { transform: rotate(180deg); }\r\n.nav-label.active::after { width: 100%; }\r\n\r\n/* ==================================\r\n   全宽 Mega Menu (PC端)\r\n================================== */\r\n.mega-menu {\r\n    position: absolute;\r\n    top: 70px;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    background: #fff;\r\n    border-bottom: 1px solid var(--border-color, #eaeaea);\r\n    box-shadow: 0 10px 30px rgba(0,0,0,0.08);\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transform: translateY(-10px);\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    pointer-events: none;\r\n}\r\n\r\n.mega-menu.open {\r\n    opacity: 1;\r\n    visibility: visible;\r\n    transform: translateY(0);\r\n    pointer-events: auto;\r\n}\r\n\r\n/* 内部内容约束在安全区内 */\r\n.mega-content {\r\n    width: 90%;\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n    padding: 40px 0;\r\n    display: flex;\r\n    justify-content: center; /* 居中内容更专业 */\r\n    gap: 60px;\r\n}\r\n\r\n.mega-content.single-column {\r\n    justify-content: flex-start;\r\n    padding-left: calc(5% + 200px); /* 让小菜单对齐上面的文字 */\r\n}\r\n\r\n.mega-content.services-menu {\r\n    justify-content: center;\r\n    padding: 32px 0 36px;\r\n}\r\n\r\n.services-menu-grid {\r\n    width: 100%;\r\n    max-width: 720px;\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 22px;\r\n}\r\n\r\n.service-feature-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n    padding: 24px 26px;\r\n    border-radius: 22px;\r\n    text-decoration: none;\r\n    color: var(--text-main, #333);\r\n    background:\r\n        radial-gradient(circle at top right, rgba(217, 0, 27, 0.08), transparent 34%),\r\n        linear-gradient(145deg, #ffffff 0%, #f7f7f7 100%);\r\n    border: 1px solid rgba(217, 0, 27, 0.14);\r\n    box-shadow: 0 16px 36px rgba(0,0,0,0.06);\r\n    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;\r\n}\r\n\r\n.service-feature-card:hover {\r\n    transform: translateY(-4px);\r\n    border-color: rgba(217, 0, 27, 0.35);\r\n    box-shadow: 0 20px 40px rgba(217, 0, 27, 0.12);\r\n}\r\n\r\n.service-feature-tag {\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.08em;\r\n    text-transform: uppercase;\r\n    color: var(--accent-red, #d9001b);\r\n}\r\n\r\n.service-feature-title {\r\n    font-size: 1.05rem;\r\n    font-weight: 600;\r\n    line-height: 1.6;\r\n    color: var(--text-main, #333);\r\n}\r\n\r\n.mega-divider {\r\n    width: 1px;\r\n    background: var(--border-color, #eaeaea);\r\n    margin: 0 20px;\r\n}\r\n\r\n.mega-section { display: flex; flex-direction: column; flex: 1; max-width: 500px; }\r\n.mega-columns { display: flex; gap: 40px; margin-top: 15px; }\r\n.mega-column { flex: 1; }\r\n\r\n.mega-title {\r\n    font-size: 1.2rem;\r\n    color: var(--accent-red, #d9001b);\r\n    font-weight: 700;\r\n    border-bottom: 2px solid var(--accent-red, #d9001b);\r\n    padding-bottom: 8px;\r\n    display: inline-block;\r\n    width: fit-content;\r\n}\r\n\r\n.overseas-title { color: #666; border-color: transparent; }\r\n\r\n.mega-subtitle {\r\n    font-size: 1.05rem;\r\n    color: var(--accent-red, #d9001b);\r\n    margin-bottom: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-weight: 600;\r\n}\r\n.mega-subtitle::before { content: '▶'; font-size: 0.65rem; }\r\n\r\n.mega-list {\r\n    border-left: 2px solid var(--accent-red, #d9001b);\r\n    padding-left: 15px;\r\n    margin-left: 5px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n}\r\n.mega-list.no-border { border-left: none; padding-left: 0; margin-left: 0; }\r\n\r\n.mega-list a {\r\n    color: #555;\r\n    font-size: 0.95rem;\r\n    text-decoration: none;\r\n    transition: all 0.2s ease;\r\n    position: relative;\r\n    width: fit-content;\r\n}\r\n\r\n.mega-list a:hover {\r\n    color: var(--accent-red, #d9001b);\r\n    transform: translateX(5px); /* 悬浮小动效 */\r\n}\r\n\r\n.nav-item > .mega-menu.small {\r\n    min-width: 280px;\r\n}\r\n\r\n/* 杂项 */\r\n.nav-actions { display: flex; align-items: center; gap: 20px; z-index: 1001; }\r\n.lang-switch { font-size: 0.85rem; border: 1px solid var(--border-color, #eaeaea); padding: 4px 12px; border-radius: 20px; cursor: pointer; }\r\n\r\n/* 移动端汉堡按钮 */\r\n.mobile-menu-btn {\r\n    display: none;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n    cursor: pointer;\r\n    width: 30px;\r\n    height: 24px;\r\n    justify-content: center;\r\n}\r\n.mobile-menu-btn span {\r\n    width: 100%;\r\n    height: 2px;\r\n    background: var(--text-main, #333);\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    border-radius: 2px;\r\n}\r\n\r\n/* 汉堡变X动画 */\r\n.mobile-menu-btn.open span:nth-child(1) { transform: translateY(8px) rotate(45deg); }\r\n.mobile-menu-btn.open span:nth-child(2) { opacity: 0; transform: translateX(-10px); }\r\n.mobile-menu-btn.open span:nth-child(3) { transform: translateY(-8px) rotate(-45deg); }\r\n\r\n/* ==================================\r\n   移动端响应式 (<= 992px)\r\n================================== */\r\n@media (max-width: 992px) {\n    .nav-actions { display: flex; }\n    .lang-switch { display: none; } /* 移动端可以考虑把语言切换放到菜单里面，这里先隐藏 */\n    .mobile-menu-btn { display: flex; }\n\r\n    /* 移动端侧边抽屉/全屏菜单 */\r\n    .nav-links {\n        position: fixed;\n        top: 70px;\n        left: -100%; /* 默认隐藏在左侧 */\n        width: 100vw;\r\n        height: calc(100vh - 70px);\r\n        background: #fff;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: stretch;\r\n        padding: 20px;\r\n        gap: 0;\r\n        transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n        overflow-y: auto;\n    }\n\n    .mobile-lang-panel {\n        display: grid;\n        gap: 10px;\n        padding: 0 0 18px;\n        margin-bottom: 6px;\n        border-bottom: 1px solid var(--border-color, #eaeaea);\n        list-style: none;\n    }\n\n    .mobile-lang-title {\n        font-size: 0.76rem;\n        font-weight: 700;\n        letter-spacing: 0.08em;\n        text-transform: uppercase;\n        color: var(--text-light, #666);\n        padding: 0 10px;\n    }\n\n    .mobile-lang-options {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 10px;\n        padding: 0 10px;\n    }\n\n    .mobile-lang-option {\n        appearance: none;\n        border: 1px solid var(--border-color, #eaeaea);\n        background: #fff;\n        color: var(--text-main, #333);\n        border-radius: 999px;\n        padding: 8px 14px;\n        font-size: 0.92rem;\n        font-weight: 600;\n        line-height: 1;\n        cursor: pointer;\n        transition: all 0.2s ease;\n    }\n\n    .mobile-lang-option.active {\n        background: var(--accent-red, #d9001b);\n        border-color: var(--accent-red, #d9001b);\n        color: #fff;\n    }\n\n    .nav-links.active { left: 0; }\n\r\n    .nav-item {\r\n        height: auto;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        border-bottom: 1px solid var(--border-color, #eaeaea);\r\n        width: 100%;\r\n    }\r\n\r\n    .nav-label {\r\n        width: 100%;\r\n        padding: 20px 10px;\r\n        font-size: 1.1rem;\r\n        display: flex;\r\n        justify-content: space-between; /* 文字和箭头分开 */\r\n    }\r\n    .nav-label::after { display: none; } /* 移动端不需要底边红线 */\r\n\r\n    /* 移动端 Mega Menu (手风琴效果) */\r\n    .mega-menu {\r\n        position: static;\r\n        width: 100%;\r\n        opacity: 1;\r\n        visibility: visible;\r\n        box-shadow: none;\r\n        border: none;\r\n        transform: none;\r\n        background: #fcfcfc;\r\n        /* 手风琴动画核心 */\r\n        max-height: 0;\r\n        overflow: hidden;\r\n        transition: max-height 0.4s ease-in-out;\r\n        pointer-events: auto;\r\n    }\r\n\r\n    .mega-menu.open {\r\n        max-height: 1500px; /* 足够大以容纳内容 */\r\n    }\r\n\r\n    .mega-content {\r\n        width: 100%;\r\n        padding: 10px 20px 30px 20px;\r\n        flex-direction: column;\r\n        gap: 30px;\r\n    }\r\n    .mega-content.single-column { padding-left: 20px; }\r\n    .services-menu-grid { grid-template-columns: 1fr; }\r\n    .service-feature-card {\r\n        display: block;\r\n        width: fit-content;\r\n        padding: 0;\r\n        margin: 0;\r\n        border-radius: 0;\r\n        background: transparent;\r\n        border: none;\r\n        box-shadow: none;\r\n        color: #555;\r\n        transition: color 0.2s ease;\r\n    }\r\n    .service-feature-tag {\r\n        display: none;\r\n    }\r\n    .service-feature-title {\r\n        font-size: 0.95rem;\r\n        font-weight: 400;\r\n        line-height: 1.6;\r\n        color: inherit;\r\n    }\r\n    .service-feature-card:hover { transform: none; color: var(--accent-red, #d9001b); }\r\n\r\n    .mega-columns { flex-direction: column; gap: 20px; }\r\n    .mega-divider { width: 100%; height: 1px; margin: 10px 0; }\r\n\r\n    .mega-list a:hover { transform: none; color: var(--accent-red, #d9001b); }\r\n}\r\n@media (max-width: 992px) {\n    /* 核心修复：在手机端彻底禁用 PC 端的背景遮罩，防止逻辑冲突 */\r\n    .menu-backdrop {\r\n        display: none !important;\r\n    }\r\n\r\n    .nav-actions { display: flex; }\r\n    .lang-switch { display: none; }\r\n    .mobile-menu-btn { display: flex; }\r\n\r\n    .nav-links {\n        position: fixed;\n        top: 70px;\n        left: -100%;\r\n        width: 100vw;\r\n        height: calc(100vh - 70px);\r\n        background: #fff;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: stretch;\r\n        padding: 20px;\r\n        gap: 0;\r\n        transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1);\r\n        overflow-y: auto;\r\n        z-index: 1000;\n    }\n\n    .mobile-lang-panel {\n        display: grid;\n    }\n\r\n    .nav-links.active { left: 0; }\r\n\r\n    /* 移动端菜单项样式 */\r\n    .nav-item {\r\n        height: auto;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        border-bottom: 1px solid #eee;\r\n        width: 100%;\r\n    }\r\n\r\n    .nav-label {\r\n        width: 100%;\r\n        padding: 20px 10px;\r\n        font-size: 1.1rem;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .nav-label::after { display: none; }\r\n\r\n    /* 手机端展开动画 */\r\n    .mega-menu {\r\n        position: static;\r\n        width: 100%;\r\n        opacity: 1;\r\n        visibility: visible;\r\n        box-shadow: none;\r\n        border: none;\r\n        transform: none;\r\n        background: #f9f9f9;\r\n        max-height: 0;\r\n        overflow: hidden;\r\n        transition: max-height 0.4s ease-in-out; /* 关键：展开动画 */\r\n    }\r\n\r\n    .mega-menu.open {\r\n        max-height: 2000px; /* 设一个足够大的高度以容纳长列表 */\r\n    }\r\n\r\n    .mega-content {\r\n        width: 100%;\r\n        padding: 8px 10px 18px 10px;\r\n        flex-direction: column;\r\n        gap: 12px;\r\n    }\r\n\r\n    .mega-content.single-column { padding-left: 10px; }\r\n    .services-menu-grid {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 12px;\r\n        padding-left: 15px;\r\n        margin-left: 5px;\r\n    }\r\n    .service-feature-card {\r\n        width: fit-content;\r\n        padding: 0;\r\n        margin: 0;\r\n        border-radius: 0;\r\n        background: transparent;\r\n        border: none;\r\n        box-shadow: none;\r\n        color: #555;\r\n        transition: color 0.2s ease;\r\n    }\r\n    .service-feature-tag {\r\n        display: none;\r\n    }\r\n    .service-feature-title {\r\n        font-size: 0.95rem;\r\n        font-weight: 400;\r\n        line-height: 1.6;\r\n        color: inherit;\r\n    }\r\n    .service-feature-card:hover { transform: none; color: var(--accent-red, #d9001b); }\r\n    .mega-columns { flex-direction: column; gap: 20px; }\r\n    .mega-divider { display: none; } /* 手机端不需要分割线 */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
